export default "__VITE_ASSET__ByMzvx5X__"